import angular from 'angular';

import CarsNgTracking from 'cars-ng-tracking';
import NgAd from 'cars-ng-ad';
import Listing from '../listing/index';

import component from './photoLightbox.component';
import service from './photoLightbox.service';

import './photoLightbox.scss';

export default angular.module('cars.enhanced.vdp.photoLightbox', [
    Listing,
    'cars.ui.angular',
    CarsNgTracking,
    NgAd
])

    .component('photoLightbox', component)
    .service('photoLightboxService', service)
    .name;
